module.exports = __webpack_public_path__ + "../resources/img/ic_zoomout_gray950.27745f3b.svg";